import { getAllDateArr } from '@utils/index';
import type { IDateObj } from '@type/index';

const MIN_MONTH = 1;
const MAX_MONTH = 12;
const DAY_LENGTH = 7;
export const CALC_DIR = {
    PLUS: 'plus',
    MINUS: 'minus'
};
export const CAL_TYPE = {
    MONTH: 'month',
    WEEK: 'week'
};

// 요일 반환
const getDay = (value: IDateObj) => {
    const { year, month, date } = value || {};
    return year && month && date ? new Date(`${year}/${month}/${date}`)?.getDay() : 0;
};

// 주 계산
const getWeek = (ymdDateObj: Omit<IDateObj, "day" | "week">) => {
    const { year, month, date } = ymdDateObj || {};
    const firstDay = getFirstDay(year, month);
    return Math.ceil((date + firstDay) / DAY_LENGTH); // 해당 월의 1일의 요일을 더해서 나눠야 달력 그릴 때 오차가 생기지 않음
};

// dateObj로 변환
export const setDateObj = (value?: string) => {
    const d = !value ? new Date() : new Date(value);
    const year = d?.getFullYear();
    const month = d?.getMonth() + 1;
    const date = d?.getDate();
    const day = d?.getDay();

    return {
        year,
        month,
        date,
        day
    };
};

// 동일한 날짜인지 dateObj 비교
export const compareDateObj = (dateObjA: IDateObj, dateObjB: IDateObj) => {
    const dateA = `${dateObjA?.year}.${dateObjA?.month}.${dateObjA?.date}`;
    const dateB = `${dateObjB?.year}.${dateObjB?.month}.${dateObjB?.date}`;
    return dateA === dateB;
};

// 해당 월 1일 요일 인덱스 반환
const getFirstDay = (year: number, month: number) => {
    if(!year || !month) {
        return 0;
    }

    return new Date(year, month - 1, 1)?.getDay();
};

// 달력 그리기(주, 일요일부터 시작)
export const setWeekDateArr = (value: IDateObj, week?: number) => {
    const { year, month } = value;
    const allDateCount = getAllDateArr(year)[month - 1];
    const firstDay = getFirstDay(year, month);
    let weekDateArr: number[] = [];
    
    week = week || getWeek(value);

    for(let day = 0; day < DAY_LENGTH; day++) { // 일(date)
        let weekDate = 1 + ((week - 1) * DAY_LENGTH) - firstDay + day;
        weekDateArr[day] = weekDate < 1 || weekDate > allDateCount ? 0 : weekDate;
    }

    return weekDateArr;
};

// 달력 그리기(월)
export const setMonthDateArr = (value: IDateObj) => {
    const { year, month } = value;
    const allDateCount = getAllDateArr(year)[month - 1];
    const allWeek = getWeek({year, month, date: allDateCount});
    let monthDateArr: number[][] = [];

    for(let week = 1; week <= allWeek; week++) { // 주(week)
        monthDateArr[week - 1] = setWeekDateArr(value, week);
    }

    return monthDateArr;
};

// 월 +/- 계산
export const setCalcMonthDateObj = (value: IDateObj, dir: typeof CALC_DIR[keyof typeof CALC_DIR]) => {
    const { year, month } = value;
    let calcYear = year;
    let calcMonth = dir === CALC_DIR.MINUS ? month - 1 : month + 1;

    if(calcMonth > MAX_MONTH) {
        calcYear++;
        calcMonth = MIN_MONTH;
    } else if(calcMonth < MIN_MONTH) {
        calcYear--;
        calcMonth = MAX_MONTH;
    }

    return {
        ...value,
        year: calcYear,
        month: calcMonth,
        date: 1
    };
};

// 주 +/- 계산
export const setCalcWeekDateObj = (value: IDateObj, dir: typeof CALC_DIR[keyof typeof CALC_DIR]) => {
    const { year, month, date } = value;
    const day = getDay(value);
    let calcYear = year;
    let calcMonth = month;
    let allDateCount = getAllDateArr(year)[month - 1];
    let calcDate = dir === CALC_DIR.MINUS ? date - DAY_LENGTH : date + DAY_LENGTH;
    let weekFirstDate = calcDate - day;

    if(calcDate > allDateCount) {
        calcDate = allDateCount;

        if(weekFirstDate > allDateCount) {
            // 다음달로 변경
            calcMonth++;
            if(calcMonth > MAX_MONTH) {
                calcYear++;
                calcMonth = MIN_MONTH;
            }
            calcDate = 1;
        }
    } else if(calcDate < 1) {
        calcDate = 1;

        if(weekFirstDate < 1) {
            // 이전달로 변경
            calcMonth--;
            if(calcMonth < MIN_MONTH) {
                calcYear--;
                calcMonth = MAX_MONTH;
            }
            allDateCount = getAllDateArr(calcYear)[calcMonth - 1];
            calcDate = allDateCount;
        }
    }

    return {
        ...value,
        year: calcYear,
        month: calcMonth,
        date: calcDate
    };
};

